// AI-CONTEXT: See docs/features/impact-in-beeld-hub.md

/**
 * Turns a product name into a URL-safe slug: lowercase, diacritics stripped,
 * everything non-alphanumeric collapsed to single hyphens.
 *
 * @param {string|null|undefined} name - the product name
 * @returns {string} the slug, or '' when nothing usable remains
 */
const slugify = (name) => {
  if (typeof name !== 'string') return ''

  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/**
 * Slug that does not collide with existing slugs: first collision gets -2,
 * then -3, and so on. Generated once at product creation; never changed on edit.
 *
 * @param {string|null|undefined} name - the product name
 * @param {string[]} [existingSlugs] - slugs already in use within the tenant
 * @returns {string} a unique slug ('product' as fallback for empty names)
 */
const uniqueSlug = (name, existingSlugs = []) => {
  const base = slugify(name) || 'product'
  const taken = new Set(existingSlugs)

  if (!taken.has(base)) return base

  let counter = 2
  while (taken.has(`${base}-${counter}`)) {
    counter += 1
  }

  return `${base}-${counter}`
}

export { slugify, uniqueSlug }
